import FileLoaderService from './fileLoaderService';
import { DicomMetadataStore } from '@ohif/core';
import { unzip } from 'unzipit';
import isImportant from '../../../../../orthopred/utils/isImportant';

//console.log('platform/viewer/src/routes/Local/filesToStudies.js');

const { rulesDict } = require('../../../../../orthopred/utils/rulesDict');
const toKeep = ['_meta', '_vrMap', 'imageId', 'url', 'PixelData'];

var foundMR = false;

function setAge(dicomJSONDataset) {
  var age =
    parseInt(dicomJSONDataset.StudyDate.slice(0, 4)) -
    parseInt(dicomJSONDataset.PatientBirthDate.slice(0, 4));
  if (!isNaN(age)) {
    if (
      parseInt(dicomJSONDataset.StudyDate.slice(4, 8)) -
        parseInt(dicomJSONDataset.PatientBirthDate.slice(4, 8)) <
      0
    ) {
      age -= 1;
    }
  } else {
    var agestring = dicomJSONDataset.PatientAge;
    if (agestring.slice(-1) === 'Y') {
      age = parseInt(agestring);
    } else {
      age = 0;
    }
  }
  return `${age.toString().padStart(3, '0')}Y`;
}

async function addfiletometadata(file) {
  const fileLoaderService = new FileLoaderService(file);
  const imageId = fileLoaderService.addFile(file);
  const image = await fileLoaderService.loadFile(file, imageId);
  const dicomJSONDataset = await fileLoaderService.getDataset(image, imageId);

  if (
    dicomJSONDataset.SOPClassUID === '1.2.840.10008.5.1.4.1.1.4' ||
    dicomJSONDataset.SOPClassUID === '1.2.840.10008.5.1.4.1.1.4.4' ||
    dicomJSONDataset.SOPClassUID === '1.2.840.10008.5.1.4.1.1.4.1'
  ) {
    dicomJSONDataset.PatientAge = setAge(dicomJSONDataset);

    for (var tag in dicomJSONDataset) {
      if (toKeep.includes(tag, 0)) {
        continue;
      }

      if (rulesDict.hasOwnProperty(tag)) {
        if (rulesDict[tag] != '') {
          dicomJSONDataset[tag] = rulesDict[tag];
        }
      } else {
        delete dicomJSONDataset[tag];
      }
    }

    DicomMetadataStore.addInstance(dicomJSONDataset);
  } else {
    console.warn('Not MR! SOP Class UID:', dicomJSONDataset.SOPClassUID);
  }
}

const processFile = async file => {
  // console.log('platform/viewer/src/routes/Local/filesToStudies.js:   processFile    ', file.name);

  var lc_fname = file.name.toLowerCase();
  var ext = lc_fname.split('.').pop();

  if (ext != 'zip') {
    if (file.size < 50 * 1024 * 1024) {
      // 2
      try {
        await addfiletometadata(file);
      } catch (error) {
        // console.log(
        //   error.name,
        //   ':Error when trying to load and process local files:',
        //   error.message
        // );
      }
    } else {
      console.warn(
        'file size:',
        file.size / 1024 / 1024,
        'MB, too big to load!'
      );
    }
  } else if (ext === 'zip') {
    try {
      const { entries } = await unzip(file);
      for (const [name, entry] of Object.entries(entries)) {
        // a fájlnévben lehet máshol is pont (pl. dátum), és ha nincs kiterjesztés akkor hibát okozhat, ezért van 'lc_zip_name_ext.length != 3 '
        if (entry.size < 50 * 1024 * 1024) {
          // 2
          const blob = await entries[name].blob('image/png');
          try {
            await addfiletometadata(blob);
          } catch (error) {
            // console.log(
            //   error.name,
            //   ':Error when trying to load and process file from zip:',
            //   error.message
            // );
          }
        } else {
          console.warn('file inside zip is too big to load!');
        }
      }
    } catch (error) {
      console.error('error in unzip, error message:', error.message);
    }
  }
};

function getPlaneAndWeight(tags) {
  var pl = undefined;
  var sd = undefined;
  var wght = undefined;

  // console.log('getplwght', tags);

  if (tags.RepetitionTime < 1200) {
    wght = 'T1';
  } else {
    if (tags.EchoTime) {
      if (tags.EchoTime < 80) {
        wght = 'PD';
      } else {
        wght = 'T2';
      }
    } else {
      wght = undefined;
    }
  }

  // console.log('getplwght', pl, sd, wght);

  if (tags.ScanOptions) {
    if (tags.ScanOptions.includes('FS')) {
      wght += '_FS';
    } else if (
      tags.SeriesDescription.includes('STIR') ||
      tags.InversionTime != 0
    ) {
      wght += '_STIR';
    }
  } else if (tags.SeriesDescription.includes('FS')) {
    wght += '_FS';
  }

  // console.log('getplwght', pl, sd, wght);

  const planes = {
    SAG: [
      [-0.709, 0.709],
      [0.709, 1],
      [-0.709, 0.709],
      [-0.25, 0.25],
      [-0.709, 0.709],
      [-1, -0.709],
    ],
    COR: [
      [0.709, 1],
      [-0.709, 0.709],
      [-0.709, 0.709],
      [-0.709, 0.709],
      [-0.25, 0.25],
      [-1, -0.709],
    ],
    AX: [
      [0.709, 1],
      [-0.709, 0.709],
      [-0.25, 0.25],
      [-0.709, 0.709],
      [0.709, 1],
      [-0.25, 0.25],
    ],
  };

  if (tags.ImageOrientationPatient) {
    for (const [plane, value] of Object.entries(planes)) {
      var found = true;
      for (
        let index = 0;
        index < tags.ImageOrientationPatient.length;
        index++
      ) {
        var io = parseFloat(tags.ImageOrientationPatient[index]);
        var p0 = parseFloat(value[index][0]);
        var p1 = parseFloat(value[index][1]);

        if (p0 > io || io > p1) {
          found = false;
          break;
        }
      }
      if (found) {
        // console.log('found!!', plane);
        if (wght === 'PD_STIR') {
          wght = 'T2_STIR';
        }

        // console.log('serdesc length', serdesc.length);
        if (tags.SeriesDescription.length < 48) {
          sd = plane + '_' + wght + ' (' + tags.SeriesDescription + ')';
        } else {
          sd = plane + '_' + wght;
        }
        pl = plane;
        break;
      }
    }
    if (!found) {
      sd = tags.SeriesDescription;
    }
  } else {
    sd = undefined;
  }

  // console.log('getplwght', pl, sd, wght);

  return { pl, wght, sd };
}

function getTags(instance) {
  var tags = {};
  try {
    // ha az utolsó elem hiányzik: eredmény = NaN, ha előző akkor hiba !!!!
    tags.SOPClassUID = instance.SOPClassUID;
    tags.MagneticFieldStrength = instance.MagneticFieldStrength;
    tags.ImageType = instance.ImageType;
    tags.SeriesDescription = instance.SeriesDescription;

    if (tags.SOPClassUID === '1.2.840.10008.5.1.4.1.1.4.1') {
      // Enhanced MR
      tags.NumberOfFrames = Number.parseInt(instance.NumberOfFrames);
      tags.RepetitionTime = Number.parseInt(
        instance.SharedFunctionalGroupsSequence
          .MRTimingAndRelatedParametersSequence.RepetitionTime
      );
      tags.InversionTime = Number.parseInt(
        instance.SharedFunctionalGroupsSequence.MRModifierSequence
          .InversionTimes
      );
      tags.SpectrallySelectedSuppression =
        instance.SpectrallySelectedSuppression;
      tags.EchoPlanarPulseSequence = instance.EchoPlanarPulseSequence;
      tags.EchoPulseSequence = instance.EchoPulseSequence;
    } else {
      // Legacy MR
      tags.ImageOrientationPatient = instance.ImageOrientationPatient;
      tags.EchoTime = Number.parseInt(instance.EchoTime);
      tags.RepetitionTime = Number.parseInt(instance.RepetitionTime);
      tags.ScanOptions = instance.ScanOptions;
      tags.InversionTime = Number.parseInt(instance.InversionTime);
      tags.ScanningSequence = instance.ScanningSequence;
    }
  } catch (error) {
    console.warn(
      error.name,
      ':Error when trying to load necessary dicom tags:',
      error.message
    );
  }
  return tags;
}

function checkTags(tags, serie) {
  // common tags
  if (!tags.MagneticFieldStrength) {
    var msg = "Non standard DICOM format, 'MagneticFieldStrength' tag missing";
    if (!serie.reasons.includes(msg)) {
      serie.reasons.push(msg);
    }
  }

  if (!tags.ImageType) {
    var msg = "Non standard DICOM format, 'ImageType' tag missing";
    tags.ImageType = [];
    if (!serie.reasons.includes(msg)) {
      serie.reasons.push(msg);
    }
  }

  if (!tags.SeriesDescription) {
    tags.SeriesDescription = '';
  } else {
    tags.SeriesDescription = tags.SeriesDescription.toUpperCase();
  }

  if (!tags.RepetitionTime) {
    var msg = "Non standard DICOM format, 'RepetitionTime' tag missing";
    if (!serie.reasons.includes(msg)) {
      serie.reasons.push(msg);
    }
  }

  if (!tags.InversionTime) {
    tags.InversionTime = 0;
  }
  // common end

  if (tags.SOPClassUID === '1.2.840.10008.5.1.4.1.1.4.1') {
    // Enhanced MR

    if (!tags.NumberOfFrames) {
      var msg = "Non standard DICOM format, 'NumberOfFrames' tag missing";
      if (!serie.reasons.includes(msg)) {
        serie.reasons.push(msg);
      }
    }

    if (!tags.EchoPulseSequence) {
      var msg = "Non standard DICOM format, 'EchoPulseSequence' tag missing";
      if (!serie.reasons.includes(msg)) {
        serie.reasons.push(msg);
      }
    }

    if (!tags.EchoPlanarPulseSequence) {
      var msg =
        "Non standard DICOM format, 'EchoPlanarPulseSequence' tag missing";
      if (!serie.reasons.includes(msg)) {
        serie.reasons.push(msg);
      }
    }

    if (tags.EchoPulseSequence && tags.EchoPlanarPulseSequence) {
      tags.ScanningSequence = [
        tags.EchoPulseSequence == 'SPIN' ? 'SE' : '',
        tags.EchoPlanarPulseSequence == 'YES' ? 'EP' : '',
      ];
    } else {
      tags.ScanningSequence = undefined;
      console.warn(
        'EchoPlanarPulseSequence or EchoPulseSequence tag is missing'
      );
    }

    if (tags.SpectrallySelectedSuppression) {
      tags.ScanOptions = [
        tags.SpectrallySelectedSuppression === 'FAT' ? 'FS' : '',
      ];
    } else {
      tags.ScanOptions = '';
      var msg =
        "Non standard DICOM format, 'SpectrallySelectedSuppression' tag missing";
      if (!serie.reasons.includes(msg)) {
        serie.reasons.push(msg);
      }
    }
  } else {
    // Legacy MR

    if (!tags.ImageOrientationPatient) {
      tags.ImageOrientationPatient = undefined;
      var msg =
        "Non standard DICOM format, 'ImageOrientationPatient' tag missing";
      if (!serie.reasons.includes(msg)) {
        serie.reasons.push(msg);
      }
    }
    if (!tags.EchoTime) {
      tags.EchoTime = undefined;
      var msg = "Non standard DICOM format, 'EchoTime' tag missing";
      if (!serie.reasons.includes(msg)) {
        serie.reasons.push(msg);
      }
    }

    if (!tags.ScanOptions) {
      tags.ScanOptions = '';
      var msg = "'ScanOptions' tag missing";
      if (!serie.warnings.includes(msg)) {
        serie.warnings.push(msg);
      }
    }
    if (!tags.ScanningSequence) {
      tags.ScanningSequence = '';
      var msg = "Non standard DICOM format, 'ScanningSequence' tag missing";
      if (!serie.reasons.includes(msg)) {
        serie.reasons.push(msg);
      }
    }
  }
}

function processInstance(serie, instance, tags) {
  const { pl, wght, sd } = getPlaneAndWeight(tags);

  instance.SeriesDescription = sd;

  if (!serie.Plane.includes(pl)) {
    serie.Plane.push(pl);
  }
  if (!serie.Weight.includes(wght)) {
    serie.Weight.push(wght);
  }

  var important = isImportant(tags);
  if (important != true) {
    if (!serie.reasons.includes(important)) {
      serie.reasons.push(important);
    }
  }
}

function processLegacy(serie) {
  serie.instances.forEach(instance => {
    var tags = getTags(instance);
    checkTags(tags, serie);
    processInstance(serie, instance, tags);
  });
}

function processEnhanced(serie) {
  var allFrames = 0;
  serie.MultiFrame = true;

  serie.instances.forEach(instance => {
    var tags = getTags(instance);
    checkTags(tags, serie);

    if (tags.NumberOfFrames) {
      allFrames += tags.NumberOfFrames;
    }

    instance.PerFrameFunctionalGroupsSequence.forEach(
      PerFrameFunctionalGroup => {
        try {
          tags.ImageOrientationPatient =
            PerFrameFunctionalGroup.PlaneOrientationSequence.ImageOrientationPatient;
        } catch {
          tags.ImageOrientationPatient = undefined;
          var msg =
            "Non standard DICOM format, 'PerFrameFunctionalGroup.PlaneOrientationSequence.ImageOrientationPatient' tag missing";
          if (!serie.reasons.includes(msg)) {
            serie.reasons.push(msg);
          }
        }

        try {
          tags.EchoTime = Number.parseInt(
            PerFrameFunctionalGroup.MREchoSequence.EffectiveEchoTime
          );
        } catch {
          tags.EchoTime = undefined;
          var msg =
            "Non standard DICOM format, 'PerFrameFunctionalGroup.MREchoSequence.EffectiveEchoTime' tag missing";
          if (!serie.reasons.includes(msg)) {
            serie.reasons.push(msg);
          }
        }
        processInstance(serie, instance, tags);
      }
    );
  });
  serie.FramesNumber = allFrames;
}

export default async function filesToStudies(files) {
  // console.log('filesToStudies , files:', files);

  foundMR = false;
  DicomMetadataStore.init();

  const processFilesPromises = files.map(processFile);
  await Promise.all(processFilesPromises);

  var studyInstanceUIDs = DicomMetadataStore.getStudyInstanceUIDs();
  studyInstanceUIDs.forEach(studyInstanceUID => {
    const study = DicomMetadataStore.getStudy(studyInstanceUID);

    // console.log('study:', study);

    study.inferable = false;
    study.hasMultiFrameSeries = false;
    study.problems = [];

    study.series.forEach(serie => {
      serie.Plane = [];
      serie.Weight = [];
      serie.reasons = [];
      serie.warnings = [];
      serie.MultiFrame = false;
      serie.FramesNumber = 0;

      // console.log('serie, instances no:', serie.SeriesInstanceUID, serie.instances.length);
      // console.log('serie:', serie);

      if (serie.instances[0].SOPClassUID === '1.2.840.10008.5.1.4.1.1.4.1') {
        processEnhanced(serie);
        study.hasMultiFrameSeries = true;
      } else {
        processLegacy(serie);
      }

      if (serie.Plane.length != 1 || serie.Weight.length != 1) {
        console.log(serie.instances[0].SOPClassUID);
        console.log(
          'multiplane/multiweight serie, removing',
          serie.SeriesInstanceUID
        );
        DicomMetadataStore.removeSeries(
          studyInstanceUID,
          serie.SeriesInstanceUID
        );
      } else if (!serie.MultiFrame) {
        if (serie.instances.length < 15 || serie.instances.length > 50) {
          console.log(
            'instances not in range 15-50, remove serie',
            serie.SeriesInstanceUID
          );
          DicomMetadataStore.removeSeries(
            studyInstanceUID,
            serie.SeriesInstanceUID
          );
        }
      } else if (serie.MultiFrame) {
        if (serie.FramesNumber < 15 || serie.FramesNumber > 50) {
          console.log(
            'frames not in range 15-50, remove serie',
            serie.SeriesInstanceUID
          );
          DicomMetadataStore.removeSeries(
            studyInstanceUID,
            serie.SeriesInstanceUID
          );
        }
      }
    });

    // console.log('study after series check', study);
    // console.log('st series length', study.series.length);

    if (study.series.length < 1) {
      console.warn('no series, removing study', studyInstanceUID);
      DicomMetadataStore.removeStudy(studyInstanceUID);
    } else {
      foundMR = true;
    }

    var missing = ['SAG', 'COR', 'AX'];
    const valid_weights = ['PD_FS', 'T2_FS', 'T2_STIR'];
    var FOR_UID = undefined;

    study.series.forEach(serie => {
      console.log('serie weight', serie.Weight);
      console.log('serie plane', serie.Plane);
      console.log('serie reasons', serie.reasons);

      var serie_FOR = serie.instances[0].FrameOfReferenceUID;
      if (!FOR_UID) {
        FOR_UID = serie_FOR;
      }

      if (
        serie.Weight.length === 1 &&
        valid_weights.includes(serie.Weight[0])
      ) {
        if (serie.Plane.length === 1 && missing.includes(serie.Plane[0])) {
          if (serie_FOR === FOR_UID) {
            if (serie.reasons.length === 0) {
              const i = missing.indexOf(serie.Plane[0]);
              missing.splice(i, 1);
            } else {
              study.problems.push(
                `${serie.Plane[0]}_${serie.Weight[0]} - ${serie.reasons[0]} `
              );
            }
          } else {
            study.problems.push(
              `${serie.Plane[0]}_${serie.Weight[0]} - FOR_UID mismatch `
            );
          }
        }
      }
    });

    console.log('missing:', missing);

    if (!missing.length) {
      // if (!study.hasMultiFrameSeries) {
      study.series.forEach(serie => {
        if (serie.warnings.length !== 0) {
          serie.warnings.forEach(warning => {
            if (!study.problems.includes(warning)) {
              study.problems.push(warning);
            }
          });
        }
      });
      console.log('set study inferable');
      study.inferable = true;
      // } else {
      //   study.inferable = true;
      //   study.problems.push(
      //     'Ooops, this is enhanced MR... Analisys not supported yet :('
      //   );
      // }
    } else {
      if (study.problems.length === 0) {
        var mis = '';
        missing.forEach(plane => {
          mis += plane + ', ';
        });
        mis = mis.slice(0, -2);
        study.problems.push(
          `${mis} plane PD or T2 weighted, fat supressed serie is missing. `
        );
      }
    }
  });

  studyInstanceUIDs = DicomMetadataStore.getStudyInstanceUIDs();

  return [studyInstanceUIDs, foundMR];
}
